<template>
  <validation-provider
    ref="baseInputValidationProviderRef"
    v-slot="validationContext"
    :vid="vid"
    :name="name"
    :rules="rules"
    :custom-messages="customMessages"
    slim
  >
    <b-form-group
      :label-for="'input-' + id"
      :label-class="'d-inline'"
      :class="[Object.keys(validationContext.failedRules).length !== 0 ? 'error' : null, formGroupClass]"
    >
      <template v-if="inputLabelText" #label>
        {{ inputLabelText }}
        <span v-if="requiredStar" class="text-danger">*</span>
      </template>
      <b-form-input
        :id="'input-' + id"
        v-model="displayModel"
        :state="getValidationState(validationContext)"
        :type="type"
        :placeholder="placeholder"
        :size="size"
        :autofocus="autoFocus"
        :disabled="disabled"
        :lazy="lazy"
        :name="'input-' + inputName"
        :number="numberVModel"
        :readonly="readonly"
        :class="inputClass"
        :autocomplete="'off'"
        :min="min"
        :max="max"
        :step="step"
        trim
        data-vv-validate-on="input"
        @focusout="focusout"
        @keydown="numbersOnly($event)"
      />
      <b-form-invalid-feedback v-if="customMessages" :id="'input-' + id" key="b-form-invalid-feedback-1" class="invalid-feedback-inline">
        {{ validationContext.errors[0] ? validationTextFormat(validationContext.errors[0]) : null }}
      </b-form-invalid-feedback>
      <b-form-invalid-feedback v-else :id="'input-' + id" key="b-form-invalid-feedback-2" class="invalid-feedback-inline">
        {{ validationContext.errors[0] ? validationTextFormat(validationContext.errors[0]) + "." : null }}
      </b-form-invalid-feedback>
    </b-form-group>
  </validation-provider>
</template>

<script>
import BaseModelEmitter from "../../../../mixins/baseModelEmitter";
import Vue from "vue";
import { FormPlugin, FormGroupPlugin, FormInputPlugin } from "bootstrap-vue";
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormPlugin);

export default {
  name: "BaseInput",
  mixins: [BaseModelEmitter],
  props: {
    id: {
      type: String,
      default: () => Math.floor(Math.random() * 1000 + new Date().getUTCMilliseconds()) + "",
    },
    name: {
      type: String,
      default: "",
    },
    inputLabelText: {
      type: String,
      default: "",
    },
    state: {
      type: Boolean,
      default: false,
    },
    requiredStar: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "text",
    },
    inputClass: {
      type: String,
      default: null,
    },
    autoFocus: {
      type: Boolean,
      default: false,
    },
    lazy: {
      type: Boolean,
      default: false,
    },
    numberVModel: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    formGroupClass: {
      type: String,
      default: null,
    },
    customMessages: {
      type: Object,
      default: null,
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    step: {
      type: [Number, String],
      default: null,
    },
    //eslint-disable-next-line vue/require-default-prop
    inputModel: null,
    rules: {
      // type: Object,
      type: [String, Object],
      default: null,
    },
    vid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      inputName: null,
    };
  },
  // computed: {
  //   errorClassControl() {
  //     return this.displayModel !== "" ? null : "error";
  //   },
  // },
  mounted() {
    this.inputNameFormat();
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    focusout() {
      this.$emit("focusout");
    },
    inputNameFormat() {
      if (this.inputLabelText !== null) {
        this.inputName = this.inputLabelText
          .split(" ")
          .join("-")
          .replace(/Ğ/gim, "G")
          .replace(/Ü/gim, "U")
          .replace(/Ş/gim, "S")
          .replace(/İ/gim, "I")
          .replace(/Ö/gim, "O")
          .replace(/Ç/gim, "C")
          .replace(/ğ/gim, "g")
          .replace(/ü/gim, "u")
          .replace(/ş/gim, "s")
          .replace(/ı/gim, "i")
          .replace(/ö/gim, "o")
          .replace(/ç/gim, "c")
          .toLowerCase();
      } else {
        this.inputName = "name-" + this.id;
      }
    },
    validationTextFormat(text) {
      let fiterText = text.split(" ");
      let returnText = fiterText[0];
      for (let i = 1; i < fiterText.length; i++) {
        returnText += " " + fiterText[i].charAt(0).replace(/İ/gim, "i").replace(/I/gim, "ı").toLowerCase() + fiterText[i].slice(1).toLowerCase();
      }
      return returnText;
    },
    numbersOnly(evt) {
      if (this.type === "number") {
        evt = evt ? evt : window.event;
        const charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
          evt.preventDefault();
        } else {
          return true;
        }
      }
    },
    resetValidation() {
      if (this.$refs.baseInputValidationProviderRef) {
        this.$refs.baseInputValidationProviderRef.reset();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
